import React, { useEffect } from "react";
import styled from "styled-components";
import PrivacyContent from "./PrivacyContent";
import Nav from "../template/home/Nav/Nav";
import { useTranslation } from "react-i18next";
import "../template/home/Hero/Hero.css";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import {scrollToTop} from "../redux/constants/commonFunctions"

// Styled Components
const PageContainer = styled.div`
  min-height: 100vh;
  width: 100%;
  max-width: 100vw;
  /* background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%); */
  background: #ffefef;
`;

const MainContainer = styled.main`
  /* max-width: 80vw; */
  /* width: 100%; */
  padding: 1rem 1rem;
`;

const ContentWrapper = styled.div`
  margin: 0 auto;
  max-width: 80vw;
`;

const HeroSection = styled.div`
  text-align: center;
  margin-bottom: 3rem;
`;

const Title = styled.h1`
  font-size: 2.5rem;
  font-weight: bold;
  color: #1e293b;
  margin-bottom: 1.5rem;
  background: linear-gradient(135deg, #3b82f6, #1d4ed8);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;

  @media (min-width: 768px) {
    font-size: 3rem;
  }
`;

const Description = styled.p`
  font-size: 1.125rem;
  color: #64748b;
  max-width: 36rem;
  margin: 0 auto;
`;

const LastUpdated = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1.5rem;
  font-size: 0.875rem;
  color: #94a3b8;
`;

const StyledCard = styled.div`
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05), 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e8f0;
`;

const CardContent = styled.div`
  padding: 2rem;

  @media (min-width: 768px) {
    padding: 3rem;
  }
`;

const Section = styled.section`
  margin-bottom: 2rem;
`;

const SectionTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 1rem;
  position: relative;

  &:before {
    content: "";
    position: absolute;
    left: -1rem;
    top: 50%;
    transform: translateY(-50%);
    width: 4px;
    height: 1.5rem;
    background: linear-gradient(135deg, #3b82f6, #1d4ed8);
    border-radius: 2px;
  }

  padding-left: 1rem;
`;

const SectionContent = styled.div`
  color: #475569;

  p {
    margin-bottom: 1rem;
  }

  h3 {
    color: #334155;
    margin: 1.5rem 0 0.5rem 0;
  }
`;

const List = styled.ul`
  list-style-type: none;
  padding-left: 0;
  margin: 1rem 0;

  li {
    position: relative;
    padding-left: 1.5rem;
    margin-bottom: 0.5rem;

    &:before {
      content: "•";
      color: #3b82f6;
      font-weight: bold;
      position: absolute;
      left: 0;
    }
  }
`;

const ListItem = styled.li`
  margin-bottom: 0.5rem;
`;

const Separator = styled.hr`
  border: none;
  border-top: 1px solid #e2e8f0;
  margin: 2rem 0;
`;

const SecurityGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;

  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }
`;

const SecurityCard = styled.div`
  padding: 1.5rem;
  /* background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%); */
  border: 1px solid #bfdbfe;
  border-radius: 8px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(59, 130, 246, 0.15);
  }

  h3 {
    /* color: #1d4ed8; */
    margin-bottom: 0.5rem;
  }

  p {
    color: #475569;
    margin: 0;
  }
`;

const ContactCard = styled.div`
  /* background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%); */
  padding: 1.5rem;
  border-radius: 8px;
  border: 1px solid #bbf7d0;

  div {
    margin-bottom: 1rem;

    &:last-child {
      margin-bottom: 0;
    }
  }

  h3 {
    /* color: #166534; */
    margin-bottom: 0.5rem;
  }

  p {
    color: #475569;
    margin: 0;
  }
`;

const PrivacyPolicy = () => {

  useEffect(() => {
    // Scroll to top on mount
    window.scrollTo(0, 0);
  }, []);

  return (
    <PageContainer>
      {/* <Header /> */}
      <Nav hideLang={true} />

      <MainContainer>
        <ContentWrapper>
          <PrivacyContent />
        </ContentWrapper>
      </MainContainer>

      <Footer />
    </PageContainer>
  );
};



const Footer = () => {

  const { t } = useTranslation();
  const history = useHistory();

  const handleRedirect = (path) => {
    scrollToTop();
    history.push(path);
  };


  return (
    <div className="footer-svg-wrapper">
       
      <div className="footer">
        <div className="footer-left">
          <div>
            {/* <img src="Image/HomeImages/logo-white.svg" alt="" /> */}
            <img src="/Image/HomeImages/logo.svg" alt="" />
            <p>{t("home.about")}</p>
            <div className="footer-social">
              <a
                href="https://www.facebook.com/Chalkmates-102745632283169/?ref=pages_you_manage"
                target="_blank"
              >
                <div>
                  <img
                    className="footer-img"
                    src="Image/facebook.png"
                    alt="facebook-icon"
                  />
                </div>
              </a>

              <a
                href="https://www.linkedin.com/company/chalkmates/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div>
                  <img
                    className="footer-img"
                    src="Image/linkedin.png"
                    alt="linkedin-icon"
                  />
                </div>
              </a>

              <a
                href="https://twitter.com/chalkmates"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div>
                  <img
                    className="footer-img"
                    src="Image/twitter.png"
                    alt="twitter-icon"
                  />
                </div>
              </a>

              <a
                href="https://www.instagram.com/chalkmates_team/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div>
                  <img
                    className="footer-img"
                    src="Image/instagram.png"
                    alt="instagram-icon"
                  />
                </div>
              </a>
            </div>
          </div>
        </div>
        <div className="footer-right">
          {/* <img src="Image/HomeImages/footer-image.svg" alt="" /> */}
          <div className="footer-header">
            <p>{t("HomePageRedesign.aboutUs")}</p>
          </div>
          <div className="footer-header">
            <p>{t("HomePageRedesign.support")}</p>
          </div>
          <div className="footer-header">
            <p>{t("HomePageRedesign.company")}</p>
          </div>
          <div>
            <p className={"footer-link"}>{t("HomePageRedesign.aboutUs")}</p>
          </div>
          <div>
            <p className={"footer-link"} onClick={()=>handleRedirect("/terms-and-conditions")} >{t("HomePageRedesign.termsAndConditions")}</p>
          </div>
          <div>
            <p className={"footer-link"}>{t("HomePageRedesign.faq")}</p>
          </div>
          <div>
            <p className={"footer-link"}>{t("HomePageRedesign.complaint")}</p>
          </div>
          <div>
            <p className={"footer-link"} onClick={()=>handleRedirect("/privacy")} >{t("HomePageRedesign.privacyPolicy")}</p>
          </div>
          <div>
            <p className={"footer-link"}>{t("HomePageRedesign.contactUs")}</p>
          </div>
        </div>
        {/* <Snackbar
          open={open}
          autoHideDuration={6000}
          onClose={handleClose}
          anchorOrigin={{ vertical, horizontal }}
        >
          <Alert onClose={handleClose} severity={severity}>
            {message}
          </Alert>
        </Snackbar>

        <div className="application">
          <Helmet>
            <script src="//code.tidio.co/e5kksaxjoyrmay3xbgjttl4uzvjimoho.js"></script>
          </Helmet>
        </div> */}
      </div>
      <svg className="svg-section5">
          <clipPath id="clip-path-footer" clipPathUnits="objectBoundingBox">
            <path d="M0,1 L1,1 L1,0 L0.118,0.149 C0.051,0.16,0,0.259,0,0.377 L0,1"></path>
          </clipPath>
        </svg>
      </div>
  );
}


export default PrivacyPolicy;
